import React from 'react';
import hackcovidLogoSrc from '../assets/hackcovid-logo.jpg';
import Autocomplete from 'react-google-autocomplete';

const Header = (props) => {
   return(
      <footer className="footer container-fluid">
         <div className="row align-items-center">
            <div className="col-md-4">
               <img className="footer__logo" src={hackcovidLogoSrc} alt="Hackcovid 2020" />
            </div>
            <div className="col-md-4">
               <div className="form-search">
                  <Autocomplete
                     placeholder="Pesquise por uma cidade"
                     className="form-input form-input--search"
                     onPlaceSelected={(place) => {
                        console.log(place);
                     }}
                     types={['(regions)']}
                     componentRestrictions={{country: "br"}}
                  />
               </div>
            </div>
         </div>
      </footer>
   )
}

export default Header;

